<template>
  <div class="groupBox"
    :data-view="group.viewtype || 'list'">
    <p class="groupLabel">{{group.label[lang]}}</p>
    <div class="group"
      :style="{justifyContent: group.viewtypeAlign}">
      <ControlItem class="mods"
        v-for="item in list"
        :key="item.id"
        :locale="locale"
        :lang="lang"
        :item="item"
        @setRcu="setRcu" />
    </div>
  </div>
</template>

<script>
import ControlItem from '@/components/Control/ControlItem.vue'

export default {
  name: 'ControlGroup',
  props: [
    'lang',
    'locale',
    'roomKey',
    'group'
  ],
  components: {
    ControlItem
  },
  computed: {
    list () {
      return this.group.list
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    setRcu (data) {
      this.$emit('setRcu', data)
    }
  }
}
</script>
